import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { VendorDashboardContent } from "@/components/vendor/VendorDashboardContent";
import { getStoredVendorVenueId } from "@/lib/vendorPortal";
import { LoadingBlock } from "@/components/AsyncState";

export const Route = createFileRoute("/vendor/dashboard")({
  head: () => ({
    meta: [
      { title: "Dashboard · Venue Portal" },
      { name: "description", content: "Partner dashboard with venue engagement metrics." },
    ],
  }),
  component: VendorDashboardRoute,
});

function VendorDashboardRoute() {
  const navigate = useNavigate();
  const [venueId, setVenueId] = useState<string | null>(null);

  useEffect(() => {
    const stored = getStoredVendorVenueId();
    if (!stored) {
      void navigate({ to: "/vendor/login", replace: true });
      return;
    }
    setVenueId(stored);
  }, [navigate]);

  if (!venueId) {
    return <LoadingBlock label="Dashboard laden…" />;
  }

  return <VendorDashboardContent venueId={venueId} />;
}
